import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { FormControl } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import style from './index.module.scss';

const listIndexOf = (valueList, selected) =>
  Array.isArray(valueList)
    ? valueList.findIndex((v) => String(v) === String(selected))
    : -1;

const CommonSelectField = ({ value, onChange, className, firstOptionLabel, firstOptionValue, valueList, labelList, disabledList, disabledSelect, defaultValue, widthValue, menuColor, error, key, placeholder, placeholderStyle ,readOnly, formatDisplayValue}) => {
    const contractStatus = sessionStorage.getItem('Selected Contract Status');

    return (
        <FormControl size="small" className={!widthValue && style.fullWidth} sx={widthValue && { width: widthValue }}>
            <Select
                labelId="demo-select-small"
                id="demo-select-small"
                displayEmpty
                defaultValue={defaultValue}
                value={value ?? ''}
                key={key}
                onChange={onChange}
                SelectDisplayProps={{ style: { fontSize: 14 } }}
                className={className}
                error={error}
                IconComponent={KeyboardArrowDownIcon}
                MenuProps={{
                    PaperProps: {
                        sx: {
                        maxWidth: 500, 
                        whiteSpace: 'normal'
                        }
                    },
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                }}
                disabled={(contractStatus === "ACTIVE" && !window.location.pathname.includes('moveToDraft')) ? true : disabledSelect || false}
                readOnly = {readOnly}
                renderValue={(selected) => {
                    // For Contract Category: show selected value left, red text right
                    if (placeholder) {
                        // let displayValue = '';
                        if (!selected || selected === '') {
                            // displayValue = '';
                            return (
                                 <span style={ placeholderStyle ? placeholderStyle : { color: '#8a8a8a', fontSize: '14px'}}>{placeholder}</span> );
                            }
                        if (typeof formatDisplayValue === 'function') {
                            const custom = formatDisplayValue(selected);
                            if (custom != null && String(custom).trim() !== '') {
                                return (
                                    <span style={{ color: '#222', fontSize: '14px' }}>{custom}</span>
                                );
                            }
                        }
                        //  else {
                            const selectedIndex = listIndexOf(valueList, selected);
                            const displayValue = labelList && selectedIndex >= 0 ? labelList[selectedIndex] : selected;
                        // }
                        return (
                            // <span style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <span style={{ color: '#222', fontSize: '14px' }}>{displayValue}</span>
                                // <span style={placeholderStyle ? placeholderStyle : { color: '#dc3545', fontSize: '14px' }}>{placeholder}</span>
                            // </span>
                        );
                    }
                    // Fallback to normal behavior for dropdowns without placeholder
                    if (!selected || selected === '') {
                        return <span style={{ color: '#8a8a8a', fontStyle: 'normal', fontSize: '14px' }}>Select an option</span>;
                    }
                    if (typeof formatDisplayValue === 'function') {
                        const custom = formatDisplayValue(selected);
                        if (custom != null && String(custom).trim() !== '') {
                            return (
                                <span style={{ color: '#222', fontSize: '14px' }}>{custom}</span>
                            );
                        }
                    }
                    const selectedIndex = listIndexOf(valueList, selected);
                    return labelList && selectedIndex >= 0 ? labelList[selectedIndex] : selected;
                }}
            >
                {placeholder && (
                    <MenuItem value="" disabled style={{ display: 'none' }}>
                        {placeholder}
                    </MenuItem>
                )}
                {firstOptionLabel !== '' && (
                    <MenuItem value={firstOptionValue}>{firstOptionLabel}</MenuItem>
                )}
                {valueList?.map((data, index) => (
                    <MenuItem key={`item-${data}-${index}`} value={data} disabled={disabledList ? disabledList[index] : false} 
                    style={{
                    backgroundColor: menuColor ? menuColor[index] : '',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    lineHeight: '1.4',
                    }}
                    >{labelList ? labelList[index] : data}</MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default CommonSelectField;